import React from "react";

function MainLogo({ width, height, onClick }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="37"
      // height="47"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 45 57"
      className="cursor-pointer"
      onClick={onClick}
    >
      <path
        fill="url(#paint0_linear_2_10)"
        d="M22.228 0c-1.661 5.392-4.037 8.938-5.847 11.136-1.365 1.658-3.071 3.295-6.482 6.568a241.685 241.685 0 01-5.466 5.084c-.387.33-5.166 4.564-4.337 10.847.107.803.829 5.612 5.205 8.222 5.345 3.188 11.03.046 11.353-.14 3.573-2.056 4.901-5.423 5.256-6.43.168 1.221.828 6.993-3.071 12.246-4.841 6.52-12.59 6.69-13.474 6.694a1.551 1.551 0 00-.747.595c-.369.566-.213 1.171-.185 1.27h35.506c.025-.074.205-.63-.127-1.145a1.31 1.31 0 00-.676-.52c-1.008.022-7.33.05-12.078-5.03-5.484-5.869-4.09-13.446-3.94-14.194 1.794 5.1 6.35 8.405 11.143 8.304 3.04-.064 6.335-1.571 8.39-4.448.373-.523 2.415-3.486 1.892-7.239-.32-2.296-1.705-4.07-4.465-7.52-1.775-2.22-3.23-3.753-4.72-5.312-3.099-3.246-5.152-4.98-8.075-8.833-.21-.275-.362-.473-.564-.756C25.351 7.481 23.522 4.424 22.23 0z"
      ></path>
      <path
        fill="url(#paint1_linear_2_10)"
        d="M23.118 35.203c.09.273 2.38 6.81 8.698 8.06.643.127 4.653.853 8.298-1.702 2.662-1.867 3.65-4.449 3.906-5.144.235-.639.647-1.79.624-3.305-.032-2.202-.96-3.862-1.501-4.75-2.735-4.491-7.382-8.696-11.785-13.455-3.996-4.32-5.283-6.386-5.881-7.404A33.685 33.685 0 0122.228 0c-2.132 8.3-.968 13.766.547 17.264 1.588 3.667 4.063 6.328 3.755 10.553-.237 3.246-1.996 5.778-3.412 7.386z"
      ></path>
      <path
        fill="url(#paint2_linear_2_10)"
        d="M21.91 35.288c.242 1.6.592 5.43-1.38 9.544-2.49 5.201-7.04 7.416-8.884 8.16a17.217 17.217 0 01-6.282 1.236 1.43 1.43 0 00-.505.311c-.584.563-.446 1.442-.426 1.553h35.524c.026-.08.179-.57-.1-1.066a1.341 1.341 0 00-.721-.598c-1.074.019-7.116.022-11.797-4.749-5.755-5.867-4.36-13.763-4.22-14.476l-1.209.085z"
        opacity="0.87"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_2_10"
          x1="44.629"
          x2="0"
          y1="28.046"
          y2="28.046"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#124D95"></stop>
          <stop offset="0.586" stopColor="#156FB8"></stop>
          <stop offset="1" stopColor="#2086C8"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_2_10"
          x1="44.645"
          x2="21.063"
          y1="21.727"
          y2="21.727"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9A66"></stop>
          <stop offset="1" stopColor="#F0E620"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_2_10"
          x1="40.022"
          x2="4.405"
          y1="45.648"
          y2="45.648"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C8CD"></stop>
          <stop offset="1" stopColor="#31727C"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default MainLogo;
